import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import DocumentCreationButton from 'Components/DocumentCreationButton';

const ChestCircumference = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'pulmonary.chestCircumference'} />}
      newButton={
        <DocumentCreationButton
          name="chestCircumference"
          text={'pulmonary.newMeasurement'}
          onClick={startEdit({}, 'chestCircumference')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={12} style={{ marginBottom: '1rem' }}>
              <FormattedMessage id="pulmonary.forInfants" />
            </Item>
            <Item xs={2} id={'date'}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={4} id={'fullExpiration'}>
              <FormattedMessage id={'pulmonary.chestCircumferenceAtFullExpiration'} />
            </Item>
            <Item xs={4} id={'fullInspiration'}>
              <FormattedMessage id={'pulmonary.chestCircumferenceAtFullInspiration'} />
            </Item>
          </>
        }
        contentFormat={d => (
          <>
            <Item xs={2}>{formatPartialDate(d.date)}</Item>
            <Item xs={4} style={{ fontWeight: '600' }}>
              {d.fullExpiration ? <FormattedMessage id="pulmonary.cm" values={{ value: d.fullExpiration }} /> : '-'}
            </Item>
            <Item xs={3} style={{ fontWeight: '600' }}>
              {d.fullInspiration ? <FormattedMessage id="pulmonary.cm" values={{ value: d.fullInspiration }} /> : '-'}
            </Item>
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'chestCircumference'>[];
  startEdit: StartEdit;
}

export default ChestCircumference;
